import { render } from "./ParticlesComponent.vue?vue&type=template&id=748ca364&scoped=true"
import script from "./ParticlesComponent.vue?vue&type=script&lang=js"
export * from "./ParticlesComponent.vue?vue&type=script&lang=js"

import "./ParticlesComponent.vue?vue&type=style&index=0&id=748ca364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748ca364"]])

export default __exports__